import { useState } from 'react';
import { getDeviceEvent } from '../../../services/apiServices';
import { formatDuration } from '../../../utils/normalizeEvents';
import { ArrowIcon } from '../Icons';
import ArrowRightIcon from '../ArrowRightIcon';

const ACTIONS_NA = new Set(['dock', 'undock']);

export default function IndentedDetailRow({ data, isLastRow }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [detailData, setDetailData] = useState([]);
  const columnsToShow = data.columns.filter((item) => item.id !== 'idEvent');

  const onClick = async () => {
    if (isExpanded) {
      setIsExpanded(false);
    } else {
      const results = await getDeviceEvent(data.eventId);
      const actions = results?.actions || [];
      setDetailData(actions);
      setIsExpanded(actions.length > 0);
    }
  };

  const isLastRowClass = isLastRow ? 'bottom-1/2' : 'bottom-[-20px]';

  const verticalLineClasses = `
    absolute 
    w-[1.7px] 
    bg-[#D3D6DC] 
    top-[-20px] 
    ${isLastRowClass} 
    left-[52.5px]
  `;

  const rowBgColor = isExpanded ? 'bg-[#E9E9E9]' : 'bg-[#F8F8F8]';

  return (
    <>
      <tr
        data-testid="indented-detail-row"
        className={`${rowBgColor} border-b-2 border-[#DDDFE2] whitespace-nowrap cursor-pointer relative`}
        onClick={onClick}
      >
        {columnsToShow.map((column, index) => {
          const isIndentationColumn = column.isIndentationColumn;
          return (
            <td
              key={column.id}
              className={`py-4 px-4 text-center text-black ${index === 0 ? 'pl-[50px]' : ''}`}
            >
              {isIndentationColumn ? (
                <div className="flex items-center justify-center relative">
                  <div className="relative flex items-center">
                    <div className="absolute">
                      <ArrowIcon fillColor="#ABABAD" direction={isExpanded ? 'up' : 'down'} />
                    </div>
                  </div>
                  <div className="relative flex items-center pl-12">
                    <ArrowRightIcon className="w-6 h-6" />
                    <span className={verticalLineClasses} />
                  </div>
                  <span className="pl-1">{column.value}</span>
                </div>
              ) : (
                <span>{column.value}</span>
              )}
            </td>
          );
        })}
      </tr>

      {isExpanded && (
        <tr className="bg-[#F7F7F7] border-b-2 border-[#DDDFE2]">
          <td colSpan={data.columns.length} className="relative px-4">
            <div className="ml-10 relative">
              <div className="ml-16 pt-4 pb-8">
                <table className="w-full text-black">
                  <thead>
                    <tr>
                      <th className="text-left py-2 px-4 font-bold text-center"></th>
                      <th className="text-left py-2 px-4 font-bold text-center"></th>
                      <th className="text-left py-2 px-4 font-bold text-center"></th>
                      <th className="text-left py-2 px-4 font-bold text-center">Event</th>
                      <th className="text-left py-2 px-4 font-bold text-center">Time Start</th>
                      <th className="text-left py-2 px-4 font-bold text-center">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailData.map((row, index) => {
                      const duration = ACTIONS_NA.has(row.action)
                        ? 'N/A'
                        : formatDuration(row.duration * 1000);
                      return (
                        <tr key={index}>
                          <td className="py-2 px-4 capitalize text-center"></td>
                          <td className="py-2 px-4 capitalize text-center"></td>
                          <td className="py-2 px-4 capitalize text-center"></td>
                          <td className="py-2 px-4 capitalize text-center">{row.action}</td>
                          <td className="py-2 px-4 text-center">{row.time_range}</td>
                          <td className="py-2 px-4 text-center">{duration}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
